import { useQuery } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { IAppleAdsBudgetHistoryResponse } from "../../features/Campaigns/interface/appleAds";
import { useAuth } from "../helper/useAuth";

interface UseAppleAdsBudgetHistoryParams {
  campaignId?: string | number;
}

export const useAppleAdsBudgetHistory = (
  params?: UseAppleAdsBudgetHistoryParams,
) => {
  const { selectedIntegration } = useAuth();
  return useQuery<IAppleAdsBudgetHistoryResponse, Error>({
    queryKey: [
      "apple-ads-budget-history",
      params?.campaignId,
      selectedIntegration?.value,
    ],
    queryFn: async () => {
      const queryParams = {
        ...(params?.campaignId && { campaign_id: String(params.campaignId) }),
        tracking_id: selectedIntegration?.value as string,
      };

      return httpService.get<IAppleAdsBudgetHistoryResponse>(
        API_CONFIG.path.appleAdsBudgetHistory,
        queryParams,
      );
    },
    enabled: !!selectedIntegration?.value,
  });
};
